import { ImgWaitMail } from '../../svg/automovilcr/index';
const StepAutoUsadoFinal = () => {
    return (
        <>
            <div>
                <p className="text-center lbl-color-secondary modal-lbl modal-lbl-t1 mt-50">Esta a un paso de su nueva póliza</p>
            </div>
            <div className='img-wm' >
                <ImgWaitMail />
            </div>
            <div className="">
                <p className="text-center modal-lbl lbl-color modal-lbl-t2 mb-50">Un ejecutivo de Seguros LAFISE se comunicará con usted lo antes posible para evaluación y finalización de su compra.</p>
            </div>
        </>
    );
}
export default StepAutoUsadoFinal;